// Private constant used only within this module
const CLASS_ORDER = {
  'Play Group': 0,
  Nur: 1,
  'Jr.Kg': 2,
  'Sr.Kg': 3,
};

/**
 * Generates an array of class names between start and end classes
 * @param {string} start - Starting class (can be primary class like 'Nur' or number)
 * @param {string} end - Ending class (can be primary class like 'Sr.Kg' or number)
 * @returns {string[]} Array of class names
 */
export const getClassesArray = (start: string, end: string) => {
  const classes: string[] = [];

  // Case 1: both start and end in primary
  if (start in CLASS_ORDER && end in CLASS_ORDER) {
    const startIdx = CLASS_ORDER[start];
    const endIdx = CLASS_ORDER[end];

    // Validate order
    if (startIdx > endIdx) return [];

    for (const className in CLASS_ORDER) {
      const idx = CLASS_ORDER[className];
      if (idx >= startIdx && idx <= endIdx) {
        classes.push(className);
      }
    }
    return classes;
  }

  // Case 2: both start and end are numbers
  if (!(start in CLASS_ORDER) && !(end in CLASS_ORDER)) {
    const startNum = Number(start);
    const endNum = Number(end);

    // Validate numbers
    if (isNaN(startNum) || isNaN(endNum) || startNum > endNum) return [];

    for (let i = startNum; i <= endNum; i++) {
      classes.push(i.toString());
    }

    return classes;
  }

  // Case 3: mix of primary and numbers (start must be primary, end must be number)
  if (start in CLASS_ORDER && !(end in CLASS_ORDER)) {
    const startIdx = CLASS_ORDER[start];
    const endNum = Number(end);

    // Validate end number
    if (isNaN(endNum)) return [];

    // Add primary classes from start
    for (const className in CLASS_ORDER) {
      const idx = CLASS_ORDER[className];
      if (idx >= startIdx) {
        classes.push(className);
      }
    }

    // Add numeric classes
    for (let i = 1; i <= endNum; i++) {
      classes.push(i.toString());
    }

    return classes;
  }

  console.log('Invalid combination (like number to primary)');
  // Invalid combination (like number to primary)
  return [];
};

export const isJuniorReportCardStandard = (standard?: string | number | null) => {
  const normalizedStandard = String(standard ?? '').trim().toLowerCase().replace(/\s+/g, '');
  if (!normalizedStandard) return false;

  return (
    normalizedStandard === '1' ||
    normalizedStandard === '2' ||
    normalizedStandard === 'playgroup' ||
    normalizedStandard === 'nur' ||
    normalizedStandard === 'nursery' ||
    normalizedStandard === 'jr.kg' ||
    normalizedStandard === 'jrkg' ||
    normalizedStandard === 'sr.kg' ||
    normalizedStandard === 'srkg'
  );
};
